import { create } from "zustand";

// 1. 定义更精确的类型（替换any，提升类型安全性）
interface ConnectDeviceItem {
  device: any;
  configuration: ConfigurationType | any;
  deviceInfo: any;
  /** 匠盟多设备时用于切换当前操作设备 */
  stableId?: string;
}
export interface ConfigurationType {
  adaptation: [] | null;
  displayname: string | null;
  keyboardType: string | null;
  productId: number | null;
  productName: string | null;
  solutionRovider: string | null;
  uuid: [] | null;
  vendorId: number | null;
  identifier?: string | null;
  sdkType?: number | null;
  machineBoard?: "916" | null;
  /** 第三方平台跳转地址，配置后点击设备卡片将打开该链接而非进入子应用 */
  url?: string | null;
}

interface StoreState {
  connectListStore: ConnectDeviceItem[];
  configurationNow: ConfigurationType;

  setConnectListStore: (
    list:
      | ConnectDeviceItem[]
      | ((prev: ConnectDeviceItem[]) => ConnectDeviceItem[])
  ) => void;
  setConfigurationNow: (configuration: ConfigurationType) => void;
}

type ConnectListItem = StoreState["connectListStore"][number];

/** 设备列表仅存内存，不持久化；关 tab 后由 rescan 重建 */
const useHidGlobalStore = create<StoreState>()((set) => ({
  connectListStore: [],
  configurationNow: {
    adaptation: [],
    displayname: null,
    keyboardType: null,
    productId: null,
    productName: null,
    solutionRovider: null,
    uuid: null,
    vendorId: null,
  },

  setConnectListStore: (data) =>
    set((state) => ({
      connectListStore:
        typeof data === "function" ? data(state.connectListStore) : data,
    })),
  setConfigurationNow: (data: ConfigurationType) =>
    set({ configurationNow: data }),
}));

/** @deprecated 设备列表不再持久化，始终返回内存中的列表 */
export function readPersistedConnectList(): ConnectListItem[] {
  const list = useHidGlobalStore.getState().connectListStore;
  return Array.isArray(list) ? list : [];
}

export default useHidGlobalStore;
